import Facebook from "@/pixels/providers/facebook";
import * as ERRORES from "@/config/constants/step-constants";

let context = {
  mutation: {
    payload: {
      params: {
        mje: ERRORES.ERROR_TECNICO
      }
    }
  }
};

describe("Facebook", () => {
  beforeEach(() => {
    jest.spyOn(Facebook, "enable");
    jest.spyOn(Facebook, "wait");
    jest.spyOn(Facebook, "init");
    jest.spyOn(Facebook, "mensaje");
    jest.spyOn(Facebook, "paso1");
    jest.spyOn(Facebook, "paso2");
    jest.spyOn(Facebook, "paso3");
    jest.spyOn(Facebook, "paso4");
    jest.spyOn(Facebook, "gracias");

    document.createElement = jest.fn(() => ({
      addEventListener: jest.fn()
    }));
    document.getElementsByTagName = jest.fn(() => [
      {
        appendChild: jest.fn(),
        parentNode: {
          insertBefore: jest.fn()
        }
      }
    ]);
  });

  it("configuracion exportada por defecto", () => {
    expect(Facebook).toBeDefined();
    expect(Facebook).not.toBeNull();
  });

  it("configuracion por defecto", () => {
    Facebook.enable();
    Facebook.wait();
    Facebook.init();
    Facebook.mensaje(context);

    const enableMock = jest.spyOn(Facebook, "enable");
    const waitMock = jest.spyOn(Facebook, "wait");
    const initMock = jest.spyOn(Facebook, "init");
    const mensajeMock = jest.spyOn(Facebook, "mensaje");

    expect(enableMock).toHaveBeenCalledTimes(1);
    expect(waitMock).toHaveBeenCalledTimes(1);
    expect(initMock).toHaveBeenCalledTimes(1);
    expect(mensajeMock).toHaveBeenCalledTimes(1);
  });

  it("efecto", () => {
    window.fbq = jest.fn();
    Facebook.enable();
    const enableMock = jest.spyOn(Facebook, "enable");
    expect(enableMock).toHaveBeenCalledTimes(2);
  });

  it("configuracion para los pasos", () => {
    Facebook.paso1(context);
    const paso1Mock = jest.spyOn(Facebook, "paso1");
    expect(paso1Mock).toHaveBeenCalledTimes(1);
    Facebook.paso2(context);
    const paso2Mock = jest.spyOn(Facebook, "paso2");
    expect(paso2Mock).toHaveBeenCalledTimes(1);
    Facebook.paso3(context);
    const paso3Mock = jest.spyOn(Facebook, "paso3");
    expect(paso3Mock).toHaveBeenCalledTimes(1);
    Facebook.paso4(context);
    const paso4Mock = jest.spyOn(Facebook, "paso4");
    expect(paso4Mock).toHaveBeenCalledTimes(1);
    Facebook.gracias(context);
    const graciasMock = jest.spyOn(Facebook, "gracias");
    expect(graciasMock).toHaveBeenCalledTimes(1);
  });

  it("metodo mensaje INDIVIDUO_NEGATIVO", () => {
    context = {
      mutation: {
        payload: {
          params: {
            mje: ERRORES.INDIVIDUO_NEGATIVO
          }
        }
      }
    };
    Facebook.mensaje(context);
    const mensajeMock = jest.spyOn(Facebook, "mensaje");
    expect(mensajeMock).toHaveBeenCalledTimes(2);
  });
});
